import { Link } from "react-router-dom";
import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Creating Your Account",
    intro: "Project Explore accounts are set up for schools. There is no public sign-up form on the site.",
    ordered: false,
    steps: [
      "Teacher accounts are set up for your school by an administrator.",
      <>
        Students are added by their teacher. See{" "}
        <Link to="/support/help-center/getting-started/invite-your-students" className="text-indigo-700 underline">
          Invite your students
        </Link>
        .
      </>,
      <>
        If you already have an account, go to the{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          login page
        </Link>
        .
      </>,
    ],
    tip: "If your school would like to start and you do not have a login yet, please email hello@startupsmartup.com.",
  },
  es: {
    title: "Cómo crear tu cuenta",
    intro: "Las cuentas de Project Explore se crean para cada escuela. El sitio no tiene un formulario público de registro.",
    ordered: false,
    steps: [
      "Un administrador crea las cuentas de los maestros de tu escuela.",
      <>
        El maestro agrega a sus estudiantes. Consulta{" "}
        <Link to="/support/help-center/getting-started/invite-your-students" className="text-indigo-700 underline">
          Cómo agregar a tus estudiantes
        </Link>
        .
      </>,
      <>
        Si ya tienes una cuenta, ve a la{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          página para iniciar sesión
        </Link>
        .
      </>,
    ],
    tip: "Si tu escuela quiere empezar y todavía no tienes una cuenta, por favor escribe a hello@startupsmartup.com.",
  },
};

export default function CreatingYourAccount() {
  return <HelpArticle text={TEXT} />;
}
